import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { graphql, useStaticQuery } from "gatsby"
import { fadeBottom } from "../components/animations/Animation"
import Container from "../layout/container/Container"
import MainParagraph from "../components/typography/MainParagraph"
import ModernHeading from "../components/typography/ModernHeading"
import OldSchoolHeading from "../components/typography/OldSchoolHeading"
import ButtonGhost from "../components/buttons/ButtonGhost"

const StyledSection = styled.section`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 50%;
    background: ${props => props.theme.colors.dark};
    z-index: -1;
    @media (max-width: 1069px) {
      display: none;
    }
  }
`
const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(8, 1fr);
  @media (max-width: 1069px) {
    display: flex;
    flex-direction: column;
  }
`
const StyledHeaderWrapper = styled.div`
  grid-column: 1/8;
  grid-row: 1/5;
  display: flex;
  justify-content: center;
`
const StyledContentWrapper = styled.div`
  grid-column: 1/8;
  grid-row: 5/9;
  display: flex;
  justify-content: center;
  background: ${props => props.theme.colors.dark};
`
const StyledImageWrapper = styled.div`
  grid-column: 9/13;
  grid-row: 2/8;
  @media (max-width: 1219px) {
    grid-column: 8/13;
  }
  @media (min-width: 481px) and (max-width: 1200px) {
    display: flex;
    justify-content: center;
    padding-top: 80px;
  }
  @media (max-width: 480px) {
    padding-top: 0;
  }
`

const StyledHeader = styled.div`
  padding: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1279px) {
    padding: 80px;
  }
  @media (max-width: 768px) {
    padding: 80px 40px;
  }
  @media (max-width: 569px) {
    padding: 80px 20px;
  }
`

const StyledContent = styled.div`
  padding: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1279px) {
    padding: 80px;
  }
  @media (max-width: 768px) {
    padding: 80px 40px;
  }
  @media (max-width: 569px) {
    padding: 80px 20px;
  }
`

const OverlayImageWrapper = styled.div`
  position: relative;
  width: 100%;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(40, 40, 40, 0.2);
    z-index: 1;
    pointer-events: none;
  }
  .gatsby-image-wrapper {
    filter: grayscale(100%);
  }
`

export default function HistorySection() {
  const data = useStaticQuery(graphql`
    query {
      file(
        relativePath: { eq: "ambassador.webp" }
      ) {
        childImageSharp {
          fluid(maxHeight: 720, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)

  // GSAP
  let headerRef = useRef(null)
  let contentRef = useRef(null)

  useEffect(() => {
    fadeBottom(headerRef.current, headerRef.current)
    fadeBottom(contentRef.current, contentRef.current)
  }, [])

  return (
    <StyledSection>
      <Container>
        <StyledGrid>
          <StyledHeaderWrapper>
            <StyledHeader ref={headerRef}>
              <ModernHeading>Our Story</ModernHeading>
              <OldSchoolHeading>
                A new place with a big reputation — serving the flavors people
                talk about.
              </OldSchoolHeading>
            </StyledHeader>
          </StyledHeaderWrapper>
          <StyledContentWrapper>
            <StyledContent ref={contentRef}>
              <MainParagraph>
                Origin Restaurant is based in Ethiopia, Addis Ababa — 4 Kilo,
                behind Ambassador. We focus on what matters most: flavorful
                chaofan, juicy steak sandwiches, classic hotdogs, crispy fries,
                and ice-cold drinks. Simple, consistent, and delicious.
              </MainParagraph>
              <ButtonGhost to="/history">Learn more</ButtonGhost>
            </StyledContent>
          </StyledContentWrapper>
          <StyledImageWrapper>
            <OverlayImageWrapper>
              <Img
                fluid={data.file.childImageSharp.fluid}
                alt="Origin Restaurant exterior"
              />
            </OverlayImageWrapper>
          </StyledImageWrapper>
        </StyledGrid>
      </Container>
    </StyledSection>
  )
}
